import React from 'react';

const toFiniteNumber = (value) => {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }

  if (typeof value === 'string') {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }

  return null;
};

const normalizeDigits = (value) => {
  if (typeof value !== 'number' || !Number.isFinite(value)) {
    return 2;
  }
  return value < 0 ? 0 : Math.floor(value);
};

const DollarFormatter = ({ value, fractionDigits = 2, fallback = '—' }) => {
  const numericValue = toFiniteNumber(value);
  if (numericValue === null) {
    return <span>{fallback}</span>;
  }

  const digits = normalizeDigits(fractionDigits);
  const roundingFactor = digits > 0 ? 10 ** digits : 1;
  const rounded =
    digits === 0
      ? Math.round(numericValue)
      : Math.round(numericValue * roundingFactor) / roundingFactor;

  const formattedValue = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(rounded);

  return <span>{formattedValue}</span>;
};

export default DollarFormatter;
